export const dataSocials = [
  {
    "link":"https://www.youtube.com/channel/UCrDIJSrZ5I46topcN6MoF7g",
    "name":"YouTube",
    "icon":"assets/social-icons/youtube.png",
  },
  {
    "link":"https://twitter.com/florian_shkurti",
    "name":"Twitter",
    "icon":"assets/social-icons/twitter.png",
  },
  {
    "link":" https://github.com/rvl-lab-utoronto",
    "name":"GitHub",
    "icon":"assets/social-icons/github.png",
  },
  {
    "link":"https://vectorinstitute.ai/",
    "name":"Vector Institute",
    "icon":"assets/social-icons/vector institute.png",
  },
  {
    "link":"https://robotics.utoronto.ca/",
    "name":"UofT Robotics Institute",
    "icon":"assets/social-icons/university.png",
  },
  {
    "link":"https://robotics.cs.toronto.edu/",
    "name":"CS Robotics",
    "icon":"assets/social-icons/robot-arm.png",
  },
]